<div
  class="ascenda-ngx-slider"
  [dir]="isRtl ? 'rtl' : 'ltr'"
  *ngIf="valueDistance > 0"
  (click)="clickOnSlider($event)"
>
  <div #slider class="slider-bar">
    <div
      *ngIf="isRange"
      #minButton
      role="button"
      tabindex="0"
      [attr.aria-label]="minValueAriaLabel(minValue)"
      [ngStyle]="getOffsetStyles(minValue)"
      [style.margin]="minPointerMarginStyles"
      (click)="$event.stopPropagation()"
      (keyup)="keyupMin($event)"
      class="slider-pointer min"
    >
      <span
        class="label"
        [ngStyle]="labelStyles"
        [innerHTML]="minValueLabel(minValue)"
      ></span>
    </div>
    <div
      #maxButton
      role="button"
      tabindex="0"
      [attr.aria-label]="valueAriaLabel(maxValue)"
      [ngStyle]="getOffsetStyles(maxValue)"
      [style.margin]="maxPointerMarginStyles"
      (click)="$event.stopPropagation()"
      (keyup)="keyupMax($event)"
      class="slider-pointer max"
    >
      <span
        class="label"
        [ngStyle]="labelStyles"
        [innerHTML]="valueLabel(maxValue)"
      ></span>
    </div>
    <div
      [ngStyle]="getOffsetStyles(minValue)"
      [style.width]="convertValueToPixels(maxValue - minValue) + 'px'"
      class="selected-range"
    ></div>
  </div>
</div>
